/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Empty, Select } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import INVOICES_QUERY from 'shared/graphql/query/invoices';

const { Option } = Select;
const SelectInvoiceField = (props) => {
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const { loading, error, data } = useQuery(INVOICES_QUERY, {
    variables: {
      invoice_number: invoiceNumber,
      showData: 10,
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <Select
      style={{
        width: '100%',
      }}
      allowClear
      notFoundContent={<Empty description="ไม่มีข้อมูล" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      loading={loading}
      showSearch
      placeholder="ค้นหา"
      onSearch={(value) => setInvoiceNumber(value)}
      onChange={(value) => props.onChange(value)}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {loading || error
        ? []
        : data.invoices.invoices.map((item) => (
            <Option key={item._id} value={item._id}>
              {item.invoice_number}
            </Option>
          ))}
    </Select>
  );
};

export default SelectInvoiceField;
